/**
 * "may already be on file" — the mark on a submission that resembled somebody.
 *
 * The flag has been stored on every matched submission since D12 and, until
 * 25 Sep 2026, appeared only once a person opened the submission. The list
 * could not show it: `RegistrationRequestListItem` did not carry the field.
 *
 * That is how a second person sharing a household's email and phone could
 * disappear — absorbed into the first one's record, with a stored flag nobody
 * could see. A flag that only appears after you have already decided to look is
 * not doing the job a flag exists for.
 */

import styles from './DuplicateFlag.module.css';

interface Props {
  /**
   * What it resembled. Shown when known, because "may already be on file" is a
   * prompt and "may already be on file as V-000042" is an instruction.
   */
  matchedCode?: string | null;
}

export function DuplicateFlag({ matchedCode }: Props) {
  return (
    <span
      className={styles.flag}
      title="Matched a volunteer already on file."
    >
      {matchedCode ? `· may already be on file as ${matchedCode}` : '· may already be on file'}
    </span>
  );
}
